import os from "node:os";
import path from "node:path";

function userKey(): string {
  const uid = process.getuid?.();
  if (uid !== undefined) return String(uid);
  return os.userInfo().username.replaceAll(/[^a-zA-Z0-9_.-]/gu, "_");
}

/**
 * One endpoint per operating-system user. Tests may override the endpoint so an
 * isolated real-Pi run never attaches to a user's production Sidecar.
 */
export function sidecarEndpoint(): string {
  const overridden = process.env["PI_MENTIS_SIDECAR_SOCKET"]?.trim();
  if (overridden !== undefined && overridden !== "") return overridden;
  const key = userKey();
  return process.platform === "win32"
    ? `\\\\.\\pipe\\pi-mentis-${key}`
    : path.join(os.tmpdir(), `pi-mentis-${key}.sock`);
}
